import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../constants/constant";
import { Service } from "../services/service";

const service = new Service();

export const initialState = {
  allOrganisation: [],
  loading: false,
  currentTrendId: null,
  isOrganisationAdded: false,
  organisationMaster: [],
  typeMaster: [],
  industryMaster: [],
};

export const getAllOrganisation = createAsyncThunk(
  "get-all-organisation",
  async (obj) => {
    const url = `${BASE_URL}/api/Organization/GetAllOrganizations`;
    const params = obj;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testPostApi(url, params, user_token);
    const data = response.data;
    return data;
  }
);

export const getOrganisationMaster = createAsyncThunk(
  "get-organisation-master",
  async () => {
    const url = `${BASE_URL}/api/Organization/OrganizationMaster`;
    // const params = obj;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, {}, user_token);
    const data = response.data;
    return data;
  }
);

export const getTypeMaster = createAsyncThunk("get-type-master", async () => {
  const url = `${BASE_URL}/api/Organization/OrganizationTypeMaster`;
  // const params = obj;
  const user_token = localStorage.getItem("bb_access_token");
  const response = await service.testGetApi(url, {}, user_token);
  const data = response.data;
  return data;
});

export const getIndustryMaster = createAsyncThunk(
  "get-industry-master",
  async () => {
    const url = `${BASE_URL}/api/Organization/OrganizationIndustryMaster`;
    // const params = obj;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, {}, user_token);
    const data = response.data;
    return data;
  }
);

export const createOrganisation = createAsyncThunk(
  "create-organisation",
  async ({ data }) => {
    let url = `/api/Organization/AddOrganization`;
    data = JSON.stringify(data);
    const user_token = localStorage.getItem("bb_access_token");
    let response = await service.newPostApi(url, data, user_token);
    return response;
  }
);

const organisationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    updateCurrentTrend(state, action) {
      state.currentTrendId = action.payload;
    },
  },
  extraReducers: {
    [getAllOrganisation.pending]: (state) => {
      state.loading = true;
    },
    [getAllOrganisation.fulfilled]: (state, { payload }) => {
      state.allOrganisation = payload;
      state.loading = false;
    },
    [getAllOrganisation.rejected]: (state) => {
      state.loading = false;
    },
    [getOrganisationMaster.pending]: (state) => {
      state.loading = true;
    },
    [getOrganisationMaster.fulfilled]: (state, { payload }) => {
      state.organisationMaster = payload;
      state.loading = false;
    },
    [getOrganisationMaster.rejected]: (state) => {
      state.organisationMaster = [];
      state.loading = false;
    },
    [getTypeMaster.pending]: (state) => {
      state.loading = true;
    },
    [getTypeMaster.fulfilled]: (state, { payload }) => {
      state.typeMaster = payload;
      state.loading = false;
    },
    [getTypeMaster.rejected]: (state) => {
      state.typeMaster = [];
      state.loading = false;
    },
    [getIndustryMaster.pending]: (state) => {
      state.loading = true;
    },
    [getIndustryMaster.fulfilled]: (state, { payload }) => {
      state.industryMaster = payload;
      state.loading = false;
    },
    [getIndustryMaster.rejected]: (state) => {
      state.industryMaster = [];
      state.loading = false;
    },
    [createOrganisation.pending]: (state, action) => {
      state.loading = true;
    },
    [createOrganisation.fulfilled]: (state, { payload }) => {
      state.status = payload.response.status;
      state.loading = false;
      state.isOrganisationAdded = true;
    },
    [createOrganisation.rejected]: (state, { payload }) => {
      state.loading = false;
    },
  },
});

export const { updateCurrentTrend } = organisationSlice.actions;
export default organisationSlice.reducer;
